(ns frontend.view.modals.textarea.view
  (:require
   [frontend.view.modals.textarea.events :as events]
   [frontend.bootstrap.components :as rbs]
   [frontend.utils :as fu]
   [ui.components.modal.view :as modal]))

(defonce modal-key :textarea-modal)

(defn view
  [{:keys [shown? close-modal! props state class-name topmost?]}]
  (swap! state assoc :value (:value props))
  (fn [{:keys [shown? close-modal! props state class-name topmost?]}]
    (let [{:keys [title-text button-text value on-submit!]} props]
      [modal/view
       {:visible?      (and shown? topmost?)
        :hide!         close-modal!
        :backdrop      "static"
        :close-button? true}
       title-text
       [:textarea.zap-modal__textarea
        {:on-change #(swap! state assoc
                       :value
                       (-> %
                           .-target
                           .-value))
         :value     (or (:value @state) "")}]
       [modal/right-single-button
        nil
        (or (events/form-not-ready? state)
            (events/no-changes? state (:value props)))
        (fn [_]
          (on-submit! (:value @state))
          (close-modal!))
        button-text
        nil]])))
